import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { scrollToElement } from '../../shared/dom-utils';
import { IndustryContentService } from '../../shared/industry-content.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { GamificationActivityType } from '../../shared/types/gamification-activity-type';
import { IndustryTagDto, MAX_INDUSTRIES_SELECTED } from '../../shared/types/IndustryTagDto';
import { LevelProgressDto } from '../../shared/types/LevelProgressDto';
import { IndustryContentSelectorComponent } from './industry-content-selector/industry-content-selector.component';

@Component({
  selector: 'lp2-industry-content-section',
  templateUrl: './industry-content-section.component.html',
  styleUrls: ['./industry-content-section.component.scss'],
})
export class IndustryContentSectionComponent implements OnInit, OnDestroy {
  @Input()
  set activityPoints(value: Map<GamificationActivityType, number>) {
    this.iscPoints = value ? value.get(GamificationActivityType.COMPLETE_PRACTICE_INDUSTRY) : 0;
  }
  @ViewChild('industryContentSelectorContainer')
  industryContentSelectorContainer: ElementRef;
  @ViewChild('industryContentSelector')
  industryContentSelector: IndustryContentSelectorComponent;

  iscPoints: number;
  levelProgress: LevelProgressDto;
  selectedIndustries: IndustryTagDto[];
  maxIndustriesSelected = MAX_INDUSTRIES_SELECTED;
  hideIndustryContentSelector: boolean = null;
  industryContentSelectorOpened = false;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private levelProgressService: LevelProgressService,
    private industryContentService: IndustryContentService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.levelProgressService.levelProgress$.subscribe((level: LevelProgressDto) => {
        this.levelProgress = level;
      })
    );

    this.subscriptions.add(
      this.industryContentService.selectedIndustries$.subscribe((selectedIndustries) => {
        if (this.hideIndustryContentSelector === null && selectedIndustries) {
          this.hideIndustryContentSelector = selectedIndustries.length === 0;
        }
        this.selectedIndustries = selectedIndustries;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onAddIndustry() {
    this.hideIndustryContentSelector = false;
    this.industryContentSelector.open();
    scrollToElement(this.industryContentSelectorContainer.nativeElement);
  }

  onIndustryContentSelectorToggled(opened: boolean) {
    this.industryContentSelectorOpened = opened;
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-section/industry-content-section.component.ts